import { call, put, takeLatest } from 'redux-saga/effects'
import { buyCheckoutActions, BuyCheckoutActionTypes } from '@buy/state/checkout/actions'
import { getTokenFromLocalStorage } from '@common/utils'
import { getInvoiceHistory } from '@buy/services'
import { AxiosResponse } from 'axios'
import { InvoiceHistoryResponse, InvoiceHistoryResponseData } from '@buy/state/user/state'

export function* getLatestInvoice() {
    // Get token from local storage where it was saved set after silent auth before redirecting to OnePay
    // See where it was set in src/common/utils/auth-class.ts
    const token = getTokenFromLocalStorage()
    const userToken = token?.access_token
    if (!userToken) {
        console.error('Missing token')
        return
    }

    // Retrieve accountKey from sessionStorage where it was saved before redirecting to OnePay
    // See where it was set in src/products/buy/saga/checkout-form/form-submission.ts
    const accountKey = window.sessionStorage.getItem('accountKey')
    if (!accountKey) {
        console.error('Missing accountKey')
        return
    }

    // Retrieve transactionSessionId from sessionStorage where it was saved before redirecting to OnePay
    // See where it was set in src/products/buy/saga/checkout-form/form-submission.ts
    const transactionSessionId = window.sessionStorage.getItem('transactionSessionId')
    if (!transactionSessionId) {
        console.error('Missing transactionSessionId')
        return
    }

    try {
        // Get invoice history
        const responseInvoiceHistory: AxiosResponse<InvoiceHistoryResponseData> = yield call(
            getInvoiceHistory,
            userToken,
            accountKey
        )
        const invoiceHistory = responseInvoiceHistory.data as InvoiceHistoryResponse[]

        // Handle error if no invoices in history
        if (!invoiceHistory || invoiceHistory.length === 0) {
            console.error('No invoices found')
            return
        }

        // Get Invoice
        // The account's latest invoice will be the first entry in the array
        // per documentation: https://confluence.ops.expertcity.com/display/COM/Get+invoice+history
        const invoice = invoiceHistory[0]

        // Put the invoice metadata into redux store
        yield put(buyCheckoutActions.setInvoice(invoice))
    } catch (ex) {
        console.error('Error downloading invoice', ex)
    }
}

function* initializeGetLatestInvoiceSaga() {
    yield takeLatest(BuyCheckoutActionTypes.GET_LATEST_INVOICE, getLatestInvoice)
}

export default initializeGetLatestInvoiceSaga
